import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { JobWorkspaceRecordsTable } from "@/features/jobs/components/job-workspace-records-table";
import { isNestedRecordWorkspacePath } from "@/features/jobs/lib/is-nested-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records",
)({
	component: JobWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Job workspace Records tab — table shell with outlet for record drawer / nested workspace.
 */
function JobWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedRecordWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<JobWorkspaceRecordsTable orgId={params.orgId} jobId={params.jobId} />
			<Outlet />
		</div>
	);
}
